export default {
    DELAY_3_DAYS_AFTER_FIRST_COMPLETION: 'DELAY_3_DAYS_AFTER_FIRST_COMPLETION',
    DEVICE_REQUIRED: 'DEVICE_REQUIRED',
    CONVERSIONABLE: 'CONVERSIONABLE',
};
